import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import MenuTable from "../../helpers/MenuTable";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";


export default function DayPlan(props) {


       const tabRef = useRef(0);
       const tab2Ref = useRef(0);

       const [errTab, setErrTab] = useState([]);  //z info od serwera.. 
       const [tab, setTabX] = useState(null);
       const [row, setRowX] = useState({
          men_dziennik_id: props.id,
          godzina_od: '08:00',
          godzina_do: '09:00',
          tytul: '',
          opis: '',
       });
  

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const changeView = (e ) => {

        setRowX({
          men_dziennik_id: props.id,
          godzina_od: '08:00',
          godzina_do: '09:00',
          tytul: '',
          opis: '',
       });


        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
        }



        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
             console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                        
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        }   
    
    
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    

        const getDayPlan = () => {
 
 
        
    
            props.mainView.setProgress(-2);
    
            var req = {
                id: props.id
            };
    
            fetch( Config.url + '/rest_v1_men,day_plan', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            setTabX(res.result);                            
                          
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }

        const saveData = () => {

 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        

            if(row.opis.length < 10)
            {
                props.mainView.showDialog( "Error", "Podaj opis, min. 10 znaków" , "ok" , null);  
                return;
            }


    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_men,day_plan_add', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            setView({v:'list',id:-1});
                            props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                        
                            getDayPlan();
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }


        const deleteRecord = (e) => {

                var id = e.target.getAttribute("id");
                props.mainView.showDialog( "Pytanie", "Na pewno chcesz usunąć wpis?" , "yesno" ,  (param) => {
                        
                            if(param == "yes")
                            {
                            deleteRecordYes(id)
                            }
                    } );
}

            const deleteRecordYes = (id)  => {

            
            var req = {
                id: id
            };

            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,day_plan_remove', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {     
                            getDayPlan();                                                  
                            props.mainView.showDialog( "Sukces", "Wpis został usunięty" , "ok" , (param)=>{
                                    getDayPlan();                            
                            } );  
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;

        }




        if(tab == null )
        {      
            setTabX([]);
            getDayPlan();
            return <div>....</div>
        }


 

    var viewDialog = null;

    if(view.v == "new")
    {
                viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                                    <div className="dlg_title">
                                        Nowa pozycja w ramowym planie dnia
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                
                                                                    
                                                            <div className="form_control">
                                                                <div className="fieldName">Od godziny*</div>
                                                                <InputTime   userData={props.userData} value={row.godzina_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_od" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Do*</div>
                                                                <InputTime   userData={props.userData} value={row.godzina_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_do" placeholder={":"} className='   ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>


                                                            <div className="form_control">
                                                                <div className="fieldName">Tytuł* (I śniadanie)</div>
                                                                <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Tytuł:"} className=' w300 ' req='1' firstUp="0" />
                                                            </div>


                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Opis* (min. 10 znaków)</div>
                                                                <InputTextArea   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis:"} className=' w400  h100' req='1' firstUp="0" />
                                                            </div>

                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }
        


   return (
        <div className="view_content">
            
 

            <div className="bg_center">

                  <div className="table_widget">   
                        {
                            props.status == "aktywny" &&
                            <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj pozycje</div>
                        }
                       

                            &nbsp;&nbsp;                              

                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />    
                    </div>


                   <div ref={tabRef} className="gohide">
                        <h3>{props.title} / Ramowy plan dnia</h3>  
                        <br/>&nbsp;<br/>

                              <table className="table plan_d" >
                                        {
                                                            tab.map( (item, ix) => {


                                                                    return <Fragment>

                                                                            
                                                                                <tr>
                                                                                            <td className="title">
                                                                                                <b style={{ "font-size":18 }}>{item.godzina_od} / {item.godzina_do}, {item.tytul}</b>
                                                                                            </td>                                                                                          
                                                                                    </tr>

                                                                                     <tr>
                                                                                        <td>&nbsp;</td>
                                                                                     </tr>

                                                                                    <tr>
                                                                                        <td>
                                                                                            {item.opis}
                                                                                            <br/>&nbsp;
                                                                                        </td>                                                   
                                                                                    </tr>     

                                                                    </Fragment>

                                                            } )
                                                        }

                              </table>
                   </div>

 
                    <table className="table plan_d" >
                    {
                        tab.map( (item, ix) => {


                                return <Fragment>

                                        
                                            <tr>
                                                        <td className="title">
                                                            {item.tytul}
                                                        </td>
                                                        <td className="hour">
                                                            {item.godzina_od} / {item.godzina_do}
                                                        </td>
                                                        <td rowSpan={2}>

                                                            <MenuTable>
                                                                        <ul>       
                                                                               {
                                                                                 props.status == "aktywny" &&
                                                                                 <li onClick={deleteRecord}  id={item.id}  >usuń</li>  
                                                                               }                                                                
                                                                                  
                                                                        </ul>                                                               
                                                            </MenuTable>  

                                                        </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan={2} className="borderBottomLine">
                                                        {item.opis}
                                                        <br/>&nbsp;
                                                    </td>                                                   
                                                </tr>     

                                </Fragment>

                        } )
                    }
                    </table>
                                       
         

            </div>

            {viewDialog}


        </div>
    )

}